import { Box } from "@mui/material";
import Stat from "./Stat";

export const LeftStats = ({ stats }: any) => {
  return (
    <Box
      sx={{
        height: "100%",
        maxWidth: "220px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Stat
        header="Number of registered sites"
        value={stats.numOfSites}
      />
      <Stat
        header="Total energy generated by sites today"
        value={`${
          stats ?.aggregates ? Math.round(stats.aggregates.todayEnergyGenerated / 1000) : 0
        }kWh`}
      />
      <Stat header="Projected DAI distributions for today" value={parseFloat(stats.todaysScheduledDaiPayout).toFixed(2)} />
      <Stat header="Projected SLL generation for today" value={`${
        stats ?.aggregates ? (stats.aggregates.todayEnergyGenerated / 1000).toFixed(2) : 0
        }`} />
    </Box>
  );
};

export const RightStats = ({ stats }: any) => {
  return (
    <Box
      sx={{
        height: "100%",
        maxWidth: "200px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        // alignItems: "flex-start",
      }}
    >
      <Stat
        header="Total energy generated by sites overall"
        value={`${
          stats ?.aggregates ? Math.floor(stats.aggregates.allTimeEnergyGenerated / 1000) : 0
        }kWh`}
      />
      <Stat header="Total claimed DAI" value={stats.withdrawnDaiTokens} />
      <Stat header="Total claimed SLL" value={stats.withdrawnSllTokens} />
    </Box>
  );
};
